// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mot-color[data-v-3a793ca4] {\n  background-color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
